<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body mx-3">
  <form [formGroup]="couponInfo">
    <div class="valid-coupon-container">
      <div>
        <img
          src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2016%2016'%20fill='%23000'%3e%3cpath%20d='M13.485%204.929a1%201%200%200%200-1.414-1.414L6.5%209.086%204.929%207.515a1%201%200%201%200-1.414%201.414l2.5%202.5a1%201%200%200%200%201.414%200l6-6z'/%3e%3c/svg%3e"
          alt="Valid"
          height="22"
          width="22"
          class="ms-2"
        />
        {{ "search-coupon-modal.coupon_valid" | translate }}
      </div>
      <div class="fw-light fs-6">
        {{ "search-coupon-modal.coupon_code" | translate }} {{ couponCode }}
      </div>
    </div>
    <div class="w-100">
      <div
        class="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-4"
      >
        <!-- <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "forms.name" | translate }}</label>
            <input type="text" class="form-control" formControlName="name" readonly [ngClass]="{ 'border-0 bg-transparent': inputsDisabled }" />
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.surname" | translate }}</label>
            <input type="text" class="form-control" formControlName="surname" readonly [ngClass]="{ 'border-0 bg-transparent': inputsDisabled }" />
          </div>
        </div>

        <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "forms.email" | translate }}</label>
            <input type="text" class="form-control" formControlName="email" readonly [ngClass]="{ 'border-0 bg-transparent': inputsDisabled }" />
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.telephone" | translate }}</label>
            <input type="text" class="form-control" formControlName="phone" readonly [ngClass]="{ 'border-0 bg-transparent': inputsDisabled }" />
          </div>
        </div>

        <div class="d-flex w-100 gap-2">
          <div class="w-50">
            <label class="form-label">{{ "forms.job" | translate }}</label>
              <ng-select
                [items]="professionOptions"
                [bindValue]="'id'"
                [bindLabel]="'name'"
                formControlName="profession"
                readonly
              ></ng-select>
          </div>
          <div class="w-50">
            <label class="form-label">{{ "forms.city" | translate }}</label>
            <input type="text" class="form-control" formControlName="city" readonly [ngClass]="{ 'border-0 bg-transparent': inputsDisabled }" />
          </div>
        </div> -->

        <div class="w-100 text-start mt-3">
          <span class="fw-bold fs-4">{{
            "collections.register_new_sale" | translate
          }}</span>
        </div>
        <div
          [formArrayName]="'sales'"
          class="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-2"
        >
          @for (sale of salesFormArray.controls; track sale) {
            <div [formGroupName]="$index" class="box-project w-100">
              <div class="d-flex align-items-center justify-content-between">
                <div>#{{ $index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  style="cursor: pointer"
                  (click)="removeSale($index)"
                ></i>
              </div>
              <div class="mt-2 w-100 d-flex gap-2">
                <div class="w-75">
                  <label class="form-label" for="quantity">{{
                    "collections.purchases" | translate
                  }}</label>
                  <ng-select
                    [items]="salesOptions"
                    [bindValue]="'code'"
                    [bindLabel]="'name'"
                    formControlName="code"
                    (change)="onOptionSelected($event)"
                  ></ng-select>
                </div>
                <div class="w-25">
                  <label class="form-label" for="quantity">{{
                    "forms.mq" | translate
                  }}</label>
                  <input
                    type="text"
                    class="form-control w-100"
                    formControlName="quantity"
                    (input)="onQuantityInput($event, sale.get('quantity'))"
                  />
                </div>
              </div>
            </div>
          }
        </div>

        <div class="form-group w-100 text-end">
          <a
            data-test="add-new-product"
            class="link text-decoration-underline"
            style="cursor: pointer"
            (click)="addNewProduct()"
            >{{ "collections.add_new_product" | translate }}</a
          >
        </div>

        <div class="mt-3 d-flex gap-3">
          <button
            class="btn btn-primary"
            [disabled]="!isFormValid"
            (click)="saveCouponInfo()"
          >
            {{ "button_labels.save_close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
